module.exports = __webpack_public_path__ + "media/images/pc/banner/hokepon_reserve-5f970e4b76877067cb173dd22e9e0515.png";